import { computed } from 'vue';

import { useCalculationEngine } from '../composables/useCalculationEngine';
import { useCurrentCalculator } from '../composables/useCurrentCalculator';

import { fixNumbers } from '../utils/math';

export function useCalculatorEstimated() {
  const { currentCalculator } = useCurrentCalculator();

  const { evalRules } = useCalculationEngine();

  const calculationRules = computed(() => {
    if (!currentCalculator.value) {
      return null;
    }

    return currentCalculator.value.calculation_rules
      .filter((rule) => !!rule.is_visible && rule.parent_id === null)
      .map((rule) => {
        return {
          ...rule,
          eval:
            rule.unit === '%'
              ? (Number(evalRules(rule.rules)) * 100).toFixed(2)
              : fixNumbers(evalRules(rule.rules)),
        };
      });
  });

  return {
    calculationRules,
  };
}
